module.exports = __webpack_public_path__ + "img/happy-emoji.aed07393.svg";